export class ItemListForFilters {
  selected = false;
  id: string;
  constructor(public label: string, public value: any, public numberOfElements?: number, public icon?: string) {
    this.id = this.label + '|' + this.value.toString();
  }
}
